import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database types will be generated from Supabase
export type Database = {
  public: {
    Tables: {
      users: {
        Row: {
          id: string
          email: string
          created_at: string
          updated_at: string
        }
      }
      orders: {
        Row: {
          id: string
          user_id: string
          order_number: string
          subtotal: number
          tax: number
          total: number
          pickup_date: string
          pickup_time: string
          status: 'pending' | 'ready-for-pickup' | 'completed' | 'cancelled'
          stripe_payment_id: string
          created_at: string
        }
      }
      order_items: {
        Row: {
          id: string
          order_id: string
          product_id: string
          product_type: 'wine' | 'beer' | 'membership' | 'event-ticket'
          name: string
          quantity: number
          price: number
        }
      }
      reservations: {
        Row: {
          id: string
          user_id: string
          reservation_type: 'backroom' | 'full-shop'
          date: string
          time_slot: string
          guest_count: number
          name: string
          email: string
          phone: string
          special_requests: string | null
          status: 'pending' | 'approved' | 'declined'
          created_at: string
        }
      }
      memberships: {
        Row: {
          id: string
          user_id: string
          membership_type: string
          start_date: string
          end_date: string
          status: 'active' | 'expired' | 'cancelled'
          stripe_subscription_id: string
          created_at: string
        }
      }
      reviews: {
        Row: {
          id: string
          user_id: string
          product_id: string
          product_type: 'wine' | 'beer'
          rating: 1 | 2 | 3 | 4 | 5
          comment: string
          created_at: string
          updated_at: string
        }
      }
    }
  }
}
